module.exports = __webpack_public_path__ + "img/36 fin.1bdae103.jpg";